export const styles = (theme) => ({
  title: {
    "@media screen and (min-width: 1680px)": {
      fontSize: "2rem",
      fontWeight: 500,
      color: "#000000",
      padding: 0,
      textAlign: "center",
      marginTop: "3.268%",
      textTransform: "capitalize",
      lineHeight: "normal",
    },
    "@media only screen and (min-width:800.98px) and (max-width:1679.98px)": {
      fontSize: "1.5rem",
      fontWeight: 500,
      color: "#000000",
      padding: 0,
      textAlign: "center",
      textTransform: "capitalize",
      marginTop: "3.268%",
      lineHeight: "normal",
    },

    "@media only screen and (min-width:958.98px) and (max-width:1024px) ": {
      fontSize: "1.25rem",
      fontWeight: 500,
      color: "#000000",
      textTransform: "capitalize",
      padding: 0,
      textAlign: "center",
      marginTop: "3.268%",
    },
    "@media only screen and (min-width:600.98px) and (max-width:958px) ": {
      fontSize: "1.5rem",
      fontWeight: 500,
      color: "#000000",
      textTransform: "capitalize",
      padding: 0,
      textAlign: "center",
      marginTop: "3.268%",
    },
    "@media only screen and (min-width:480px) and (max-width:600px) ": {
      fontSize: "1.125rem",
      fontWeight: 500,
      textTransform: "capitalize",
      color: "#000000",
      padding: 0,
      textAlign: "center",
      marginTop: "3.268%",
    },
  },
  gridContainer: {
    "@media screen and (min-width: 1200px)": {
      marginBottom: "1.512%",
    },
    /*---table---*/
    "@media only screen and (min-width:768.98px) and (max-width:1280px) ": {
      marginBottom: "1.512%",
    },
    "@media only screen and (min-width:480px) and (max-width:768px) ": {
      marginBottom: "1.512%",
      display: "flex",
      flexDirection: "column",
    },
  },
  rootDialogTile: {
    padding: 0,
  },
  containerSwitchandButton: {
    display: "flex",
    alignItems: "flex-end",
    flexDirection: "column",
    marginTop: "1rem",
    "@media only screen and (min-width:958.98px) and (max-width:1024px) ": {
      display: "flex",
      alignItems: "flex-end",
      flexDirection: "column",
    },
    "@media only screen and (min-width:600.98px) and (max-width:958px) ": {
      justifyContent: "start",
      flexDirection: "column",
    },
    "@media only screen and (min-width:480px) and (max-width:600px) ": {
      display: "flex",
      justifyContent: "start",
      flexDirection: "column",
    },
  },
  TextFieldGroup: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",

    "@media only screen and (min-width:600.98px) and (max-width:958px) ": {
      flexBasic: "100%",
      maxWidth: "100%",
    },
    "@media only screen and (min-width:480px) and (max-width:600px) ": {
      flexBasic: "100%",
      maxWidth: "100%",
    },
  },

  rootInputLabel: {
    fontSize: "1rem",
    "@media only screen and (min-width:768.98px) and (max-width:1024px) ": {
      fontSize: "1.125rem",
      whiteSpace: "nowrap",
    },
  },
  customInput: {
    borderBottom: "none",
    padding: "4px 0 7px",

    "&:before": {
      borderBottom: "none",
      "&:hover": {
        borderBottom: "none",
      },
    },
    "@media screen and (min-width: 1680.98px)": {
      fontSize: "1rem",
    },
    "@media screen and (min-width: 1366.98px) and (max-width: 1680px)": {
      fontSize: "1rem",
    },
    "@media only screen and (min-width:958.98px) and (max-width:1366px) ": {
      fontSize: "0.875rem",
    },
    "@media only screen and (min-width:600.98px) and (max-width:958px) ": {
      fontSize: "1.05rem",
    },
    "@media only screen and (min-width:480px) and (max-width:600px) ": {
      fontSize: "1rem",
      padding: "10px 0 10px",
    },
  },
  activeContainer: {
    width: "100%",
    "@media only screen and (min-width:480px) and (max-width:958px) ": {
      display: "flex",
      justifyContent: "space-between",
    },
  },
  GroupButton: {
    marginLeft: theme.spacing(1),
    "@media only screen and (min-width:958.98px) ": {
      display: "flex",
      width: "100%",
      flexDirection: "column",
    },
    "@media only screen and (min-width:480px) and (max-width:958px) ": {
      display: "flex",
      width: "50%",
    },
  },
  button: {
    "@media only screen and (min-width:600.98px)": {
      fontSize: "12px",
      width: "80%",
      marginBottom: "12px",
      marginRight: 12,
    },
    "@media only screen and (min-width:480px) and (max-width:600px)": {
      fontSize: "12px",
      width: "100%",
      marginRight: 16,
    },
  },
  formGroupRoot: {
    "@media only screen and (min-width:480px)": {
      flexWrap: "nowrap",
      flexDirection: "row",
      justifyContent: "center",
    },
  },
  body1: {
    fontSize: "1rem",
    marginBottom: "6.145%",
    marginRight: 8,
  },
  switchBase: {
    "&$switchChecked": {
      color: theme.palette.common.white,
      "& + $switchBar": {
        backgroundColor: "#52d869",
      },
    },
    transition: theme.transitions.create("transform", {
      duration: theme.transitions.duration.shortest,
      easing: theme.transitions.easing.sharp,
    }),
    height: 0,
  },
  switchChecked: {
    transform: "translateX(15px)",
    "& + $switchBar": {
      opacity: 1,
      border: "none",
    },
  },
  switchBar: {
    borderRadius: 13,
    width: 42,
    height: 26,
    marginTop: -13,
    marginLeft: -21,
    border: "solid 1px",
    borderColor: theme.palette.grey[400],
    backgroundColor: theme.palette.grey[500],
    opacity: 1,
    transition: theme.transitions.create(["background-color", "border"]),
  },
  switchIcon: {
    width: 24,
    height: 24,
  },
  rootSwitchIcon: {
    "@media screen and (min-width: 1200px)": {
      marginRight: 0,
      marginLeft: 0,
      marginTop: -12,
    },
    /*---table---*/
    "@media only screen and (min-width:800.98px) and (max-width:1280px)": {
      marginBottom: "6.145%",
      marginLeft: 0,
    },
    "@media only screen and (min-width:768.98px) and (max-width:800px) and (orientation:portrait)": {
      marginBottom: 14,
      marginLeft: 0,
    },
    "@media only screen and (min-width:768.98px) and (max-width:1024px) ": {
      marginBottom: "6.145%",
      marginLeft: 0,
    },
    "@media only screen and (min-width:600.98px) and (max-width:768px) ": {
      marginBottom: 18,
      marginLeft: 0,
    },
    "@media only screen and (min-width:480px) and (max-width:600px) ": {
      marginBottom: "6.145%",
      marginLeft: 0,
    },
  },
  switchIconChecked: {
    boxShadow: theme.shadows[1],
  },
  titleModule: {
    "@media only screen and (min-width:400px) ": {
      fontSize: 18,
      fontWeight: 500,
      color: "#000000",
      // marginBottom: '1.86%',
    },
  },
  formControl: {
    "@media screen and (min-width: 400px)": {
      marginBottom: "22.31%",
    },
  },

  label: {
    height: 20,
    marginBottom: 12,
    marginRight: 0,
  },
  formLabel: {
    marginBottom: "10.97%",
    textTransform: "capitalize",
    fontSize: "16px",
  },
  DialogContent: {
    backgroundColor: "#ffffff",
    height: "100%",
    padding: "24px",
    marginTop: "12px",
  },
  containerDialogContent: {
    margin: 24,
    overflow: "auto",
    background: "#ffffff",
  },
  containerExp: {
    display: "flex",
    alignItems: "center",
    background: "#f4f4f4",
    height: 40,
    position: "relative",
    width: "100%",
    marginLeft: -17,

    "@media only screen and (min-width:480px) and (max-width:600px) ": {
      marginTop: "3.624%",
      display: "flex",
      alignItems: "center",
      background: "#f4f4f4",
      height: 30,
      position: "relative",
    },
  },

  arrowRight: {
    "@media only screen and (min-width:600.98px) ": {
      width: 0,
      height: 0,
      borderTop: "20px solid transparent",
      borderBottom: "20px solid transparent",
      borderLeft: "20px solid red",
    },
    "@media only screen and (min-width:480px) and (max-width:600px) ": {
      borderTop: "15px solid transparent",
      borderBottom: "15px solid transparent",
      borderLeft: "15px solid red",
    },
  },
  square: {
    width: 118,
    height: 40,
    background: "red",
    "@media only screen and (min-width:480px) and (max-width:600px) ": {
      width: 118,
      height: 30,
      background: "red",
    },
  },
  titleLeft: {
    "@media screen and (min-width: 1440px)": {
      position: "absolute",
      top: "50%",
      left: "6%",
      transform: "translate(-50%,-50%)",
      color: "#ffffff",
    },
    "@media screen and (min-width: 1280px) and (max-width: 1439.98px)": {
      position: "absolute",
      top: "50%",
      left: "8%",
      transform: "translate(-50%,-50%)",
      color: "#ffffff",
    },
    "@media only screen and (min-width:1024.98px) and (max-width:1280px) and (orientation:landscape)": {
      position: "absolute",
      top: "50%",
      left: "6%",
      transform: "translate(-50%,-50%)",
      color: "#ffffff",
    },
    "@media only screen and (min-width:480px) and (max-width:1024px) ": {
      position: "absolute",
      top: "50%",
      left: "10%",
      transform: "translate(-50%,-50%)",
      color: "#ffffff",
    },
  },
  titleRight: {
    "@media screen and (min-width: 1200px)": {
      marginLeft: 12,
    },
    "@media only screen and (min-width:768.98px) and (max-width:1024px)": {
      fontSize: "0.875rem",
      marginLeft: 17,
    },
    "@media only screen and (min-width:480px) and (max-width:768px)": {
      fontSize: "0.75rem",
      marginLeft: 17,
    },
  },
  nameModule: {
    textTransform: "capitalize",
  },
  link: {
    textDecoration: "underline",
    cursor: "pointer",
  },
  containerLeft: {
    display: "flex",
    justifyContent: "space-around",
    flexDirection: "column",
  },
});
